module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-0ced8c0116b471b6a64d35155886df78.png";